import {
    deleteSharedDashboardLink,
    getSharedDashboardLinks,
    postShareDashboardLink,
    putSharedDashboardLink,
} from '../services/api/shareDashboard/shareDashboardApi';

import { IDashboardLink } from '../services/api/shareDashboard/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export type SharedDashboardStore = ReturnType<typeof useSharedDashboardStore>;

export const useSharedDashboardStore = defineStore('sharedDashboard', () => {
    const sharedDashboardLinks = ref<IDashboardLink[] | undefined>();
    const selectedSharedLinkLoading = ref(false);

    const createNewSharedLink = async (
        selectedDashboardId: string,
        password: string | undefined = undefined,
        expirationDate: string
    ) => {
        const response = await postShareDashboardLink({
            dashboardId: selectedDashboardId,
            password: password ?? undefined,
            expirationDate,
        });

        return response.data;
    };

    const getSharedDashboardLinksByDashboard = async (dashboardId: string) => {
        const response = await getSharedDashboardLinks({ dashboardId });
        sharedDashboardLinks.value = response.data.sharedLinks;

        return response.data;
    };

    const updateSharedDashboardLink = async (
        dashboardId: string,
        sharedLinkId: string,
        password: string | undefined = undefined,
        expirationDate: string
    ) => {
        const response = await putSharedDashboardLink({
            id: sharedLinkId,
            dashboardId,
            password: password ?? undefined,
            expirationDate: expirationDate,
        });

        sharedDashboardLinks.value = sharedDashboardLinks.value?.map((link) =>
            link.id === response.data.id ? response.data : link
        );

        return response.data;
    };

    const removeSharedDashboardLink = async (dashboardId: string, sharedLinkId: string) => {
        const response = await deleteSharedDashboardLink({
            id: sharedLinkId,
            dashboardId: dashboardId,
        });

        sharedDashboardLinks.value = sharedDashboardLinks.value?.filter(
            (link) => link.id !== sharedLinkId
        );

        return response.data;
    };

    return {
        sharedDashboardLinks,
        createNewSharedLink,
        getSharedDashboardLinksByDashboard,
        updateSharedDashboardLink,
        removeSharedDashboardLink,
        selectedSharedLinkLoading,
    };
});
